import { windowService, documentService } from './window.utils';

// left: 37, up: 38, right: 39, down: 40,
// spacebar: 32, pageup: 33, pagedown: 34, end: 35, home: 36
const keys = { 37: 1, 38: 1, 39: 1, 40: 1 };

function preventDefault(e) {
  e.preventDefault();
}

function preventDefaultForScrollKeys(e) {
  if (keys[e.keyCode]) {
    preventDefault(e);
    return false;
  }
}

// modern Chrome requires { passive: false } when adding event
let supportsPassive = false;
try {
  windowService()?.addEventListener?.(
    'test',
    null,
    Object.defineProperty({}, 'passive', {
      get: function () {
        supportsPassive = true;
        return supportsPassive;
      },
    })
  );
} catch (e) {
  throw new Error(e as string);
}

const wheelOpt = supportsPassive ? { passive: false } : false;
const divToCheckOnWheel = documentService()?.createElement?.('div');
let wheelEvent = 'mousewheel';
if (divToCheckOnWheel && 'onwheel' in divToCheckOnWheel) {
  wheelEvent = 'wheel';
}

// call this to Disable
function disableScroll() {
  windowService()?.addEventListener?.('DOMMouseScroll', preventDefault, false); // older FF
  windowService()?.addEventListener?.(wheelEvent, preventDefault, wheelOpt); // modern desktop
  windowService()?.addEventListener?.('touchmove', preventDefault, wheelOpt); // mobile
  windowService()?.addEventListener?.('keydown', preventDefaultForScrollKeys, false);
  documentService()?.querySelector?.('body').classList.add('scrolling');
}

// call this to Enable
function enableScroll() {
  windowService()?.removeEventListener?.('DOMMouseScroll', preventDefault, false);
  windowService()?.removeEventListener?.(wheelEvent, preventDefault, wheelOpt);
  windowService()?.removeEventListener?.('touchmove', preventDefault, wheelOpt);
  windowService()?.removeEventListener?.('keydown', preventDefaultForScrollKeys, false);
  setTimeout(() => {
    documentService()?.querySelector?.('body')?.classList?.remove('scrolling');
  }, 100);
}

function isScrolling(): boolean {
  return !!documentService()?.querySelector?.('body')?.classList?.contains('scrolling');
}

export { disableScroll, enableScroll, isScrolling };
